import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { TaskProcessPageModule } from 'src/app/task-process/task-process.module';
import { EngagementHistoryModule } from './engagement-history/engagement-history.module';
import { EngagementWrapperComponent } from './engagement-wrapper/engagement-wrapper.component';
import { EngagementComponent } from './engagement.component';
import { EngagementWrapperForCRMComponent } from './engagement-wrapper-for-crm/engagement.component';

const routes: Routes = [
  {
    path: 'send-message/sites/:siteId/user-external-id/:userExternalId',
    component: EngagementWrapperForCRMComponent,
  },
  {
    path: 'send-message/search',
    component: EngagementComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule.forChild(),
    RouterModule.forChild(routes),
    SharedModule,
    TaskProcessPageModule,
    EngagementHistoryModule,
  ],
  declarations: [EngagementComponent, EngagementWrapperComponent, EngagementWrapperForCRMComponent],
})
export class EngagementModule {}
